export function serviceItemFilter(serviceItem) {
    return serviceItem == 0 ? '疑难杂症' : serviceItem == 1 ? '胃病' : serviceItem == 2 ? '消化系统' : serviceItem == 3 ? '心脑血管' : serviceItem == 4 ? '精神情志' : serviceItem == 5 ? '肾脏系统' : serviceItem == 6 ? '睡眠障碍' : serviceItem == 7 ? '神经系统' : serviceItem == 8 ? '男科' : serviceItem == 9 ? '妇科' : '--'
}

export function sexFilter(sex) {
    return sex == 0 ? '女' : sex == 1 ? '男' : '未知'
}

export function relationFilter(relation) {
    return relation == 0 ? '本人' : relation == 1 ? '配偶' : relation == 2 ? '父母' : relation == 3 ? '子女' : relation == 4 ? '其他' : '--'
}

export function orderStatusFormat(value) {
    return value == 0 ? '待支付' : value == 1 ? '已支付' : value == 2 ? '已取消' : value == 3 ? '已关闭' : value == 4 ? "待发货" : value == 5 ? "待签收" : value == 6 ? "已完成" : value == 7 ? "已退货" : value == 8 ? "已退款" : value == 9 ? "拼单中" : value == 10 ? "已签收" : value == 11 ? "全部完结" : "未知";
}

export function payTypeFormat(value) {
    return value == 0 ? "微信" : value == 1 ? "支付宝" : "---";
}

export function originFormat(value) {
    return value == 0 ? '小程序' : value == 1 ? 'app' : value == 2 ? '微信H5' : '-';
}

export function trackStatusFormat(value) {
    return value == 0 ? '仅咨询' : value == 1 ? '未服药' : value == 2 ? '服药中' : value == 3 ? '已停药' : value == 4 ? '服药未回应' : '-';
}

export function classifyFilter(classify) {
    return classify == 0 ? '普通会诊' : ''
}

export function consultationOrderStatusFormat(value) {
    return value == 0 ? '待支付' : value == 1 ? '已支付' : value == 2 ? '已退款' : value == 3 ? '已取消' : "未知";
}

export function askTypeFilter(value) {
    switch (Number(value)) {
        case 1:
            return '普通'
            break;
        case 12:
            return '快捷问诊'
            break;
        case 13:
            return '补方'
            break;
        case 14:
            return '图文'
            break;
        case 15:
            return '视频'
            break;
        case 16:
            return '线下门诊'
            break;
        case 14: // 17
            return '图文问诊'
            break;
    }
}